import MenuNames from "../../../constants/Menu/MenuNames.json";
import QcDetailsV2 from "../../../views/QcDetails";
import QcFieldIdInput from "../../../views/QcDetails/QcFieldIdInput";
import QcDetailsV1 from "../../../views/QcDetails/backup";

const qualityCheckRoutes = [
  {
    menuName: MenuNames.QUALITY_CHECK,
    path: "/qc-details-v2",
    removePadding: true,
    component: QcFieldIdInput,
    exact: true,
  },
  {
    menuName: MenuNames.QUALITY_CHECK,
    path: "/qc-details",
    component: QcDetailsV1,
    exact: true,
  },
  {
    menuName: MenuNames.QUALITY_CHECK,
    path: "/qc-details/:Feid",
    component: QcDetailsV1,
    exact: true,
  },
  {
    menuName: MenuNames.QUALITY_CHECK,
    path: "/qc-details-v2/:feId",
    removePadding: true,
    component: QcDetailsV2,
    exact: true,
  },
];

export default qualityCheckRoutes;
